import {ReactElement} from 'react';
import {formatUniqueName} from '../../Contacts/ContactFormat';
import find from "../../store/find";
import {distinctFilter} from "./filters";
import {uuid} from "../../@types/schema";

/**
 * Create client labels in a flex container.
 *
 * @param {uuid[]} clientIds
 * @param {string} type - matter or lead
 * @param {string} key - a key to add to each item
 * @return {ReactElement}
 */
const renderClientLabels = (clientIds: uuid[], type: string = 'matter', key: string): ReactElement => {
    return (<div key={key} className='u-items'>
        {clientIds.filter(distinctFilter)
                  .map(cid => formatUniqueName(find('contacts', cid)))
                  .map((c, i) => <div key={`${i} ${key};${clientIds.join(':')}`}
                                 className={`u-client ${type}`}
                      >
                          {c}
                      </div>
                  )}
    </div>);
}

export default renderClientLabels;
